<template>
  <div>
    <vue-ueditor-wrap v-model="contents"  :config="myConfig"  style="width: 90%;"></vue-ueditor-wrap>
  </div>
</template>

<script>
import Setting from '@/setting'
export default {
  name: 'UeditorForm',
  props: {
    content: '',
    height: 0,
  },
  data () {
    return {
      contents: this.contents,
      myConfig: {
        autoHeightEnabled: false, // 编辑器不自动被内容撑高
        initialFrameHeight: this.height || 600, // 初始容器高度
        initialFrameWidth: '100%', // 初始容器宽度
        UEDITOR_HOME_URL: '/static/ueditor/',
        zIndex: 10, // 自定义 z-index 值
        // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
        serverUrl: Setting.serverSrc + `/adminapi/ueditorUploads`
      }
    }
  }
}
</script>

<style scoped>

</style>
